import { Component, OnInit, Input } from "@angular/core";
import { Spell } from "../../../shared/models/spell";
import { element } from "protractor";

@Component({
  selector: "app-spell-view",
  templateUrl: "./spell-view.component.html",
  styleUrls: ["./spell-view.component.scss"]
})
export class SpellViewComponent implements OnInit {

  filteredClasses: string[] = [];
  checkedList: boolean[] = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false
  ];
  allClasses: string[] = [
    "Bard",
    "Cleric",
    "Druid",
    "Paladin",
    "Ranger",
    "Sorcerer",
    "Warlock",
    "Wizard"
  ];

  @Input() spells: Spell[];

  displayedSpells: Spell[];
  searchTerm: string;

  constructor() {}

  ngOnInit() {
    this.displayedSpells = this.spells;
    this.searchTerm = "";
  }

  handleChecked(event: boolean, name: string) {
    if (event) {
      this.filteredClasses.push(name.toLocaleLowerCase());
      // push does not create a new array so the change detection in angular does not pick up on it we force
      // a new array to be created here so that the search updates on addition and not just removal of filters
      // there is probably a more elegant way of doing this
      this.filteredClasses = this.filteredClasses.concat([]);
    } else {
      this.filteredClasses = this.filteredClasses.filter(
        ac => ac !== name.toLocaleLowerCase()
      );
    }

    this.Filter();
  }

  Filter() {
    this.FilterOnClass(this.FilterOnSearch());
  }

  FilterOnSearch(): Spell[] {
    if (!this.spells) {
      return;
    }

    return this.spells.filter(it => {
      return it.name.toLowerCase().includes(this.searchTerm.toLowerCase());
    });
  }

  FilterOnClass(spells: Spell[]) {
    if (!this.filteredClasses) {
      return;
    }

    if (this.filteredClasses.length === 0) {
      this.displayedSpells = spells;
      return;
    }

    this.displayedSpells = spells.filter(spell => {
      return spell.classes.some(spellClasses =>
        this.filteredClasses.includes(spellClasses.toLowerCase())
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/spell-dashboard/components/spell-view/spell-view.component.ts